<script lang="ts" setup>
import type { FooterColumnLinks } from "~~/models/links";

defineProps<{ links: FooterColumnLinks[] }>();
</script>

<template>
  <div class="grid md:grid-cols-3 xl:grid-cols-3 xl:gap-4">
    <div v-for="item in links" :key="item.label" class="mb-8 xl:mb-0">
      <div class="mb-4 font-bold">
        {{ item.label }}
      </div>
      <ul>
        <li v-for="child in item.children" :key="child.label" class="mb-2">
          <NuxtLink :to="child.to" :target="getTarget(child.to)" class="hover:underline">
            {{ child.label }}<UIcon name="i-ph-arrow-right" class="ms-1 align-middle" />
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
</style>
